function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useMemo } from "react";
import { ItemMemberLevel } from "sprout-graphql";
import { getItemUrl, isPresent } from "sprout-lib";
import { Box, Flex, Text } from "sprout-ui-primitives";
import styled, { css } from "styled-components";
import { media } from "sprout-ui-theme";
import { LockOutlined as BaseLockOutlined, PushPinOutlined } from "sprout-ui-icons";
import { Button } from "sprout-ui-dom";
import ItemImage from "../ItemImage";
import { Card, CardContent, CardLink } from "../Card";
import Avatar from "../Avatar";
import RenderIfChildExists from "../RenderIfChildExists";
import useStarTopic from "./graphql/mutations/useStarTopic";
const TopicWrapper = styled(Card)`
  ${media.up("medium")} {
    padding-left: 0;
    padding-right: 0;
  }

  ${({ $showBorder  })=>!$showBorder && css`
      ::before,
      ::after {
        content: none;
      }
    `}
`;
const TopicImage = styled(ItemImage)`
  width: 56px;
  height: 56px;

  ${media.up("medium")} {
    width: 24px;
    height: 24px;
  }
`;
const TopicDataWrapper = styled(Box)``;
const LockOutlined = styled(BaseLockOutlined)`
  width: 18px;
  height: 18px;
`;
const TopicOwnerDesktop = styled(Text)`
  ${media.down("medium")} {
    display: none;
  }
`;
const TopicOwnerMobile = styled(Text)`
  ${media.up("medium")} {
    display: none;
  }
`;
const TopicMembersWrapper = styled(Flex)`
  flex-direction: row-reverse;

  * + * {
    margin-right: -6px;
  }
`;
const TopicPinButton = styled(Button)`
  margin-top: -12px;
  margin-bottom: -12px;
`;
const Topic = /*#__PURE__*/ forwardRef(function TopicForwardRef(props, ref) {
    const { topic , showBorder =true , showTeam =true , navigationItemHelpers  } = props, rest = _objectWithoutProperties(props, [
        "topic",
        "showBorder",
        "showTeam",
        "navigationItemHelpers"
    ]);
    const { nodeId , id , currentUserHasStarred , rootTopicOrSelf , linkImages , type , title , teamVisible ,  } = topic;
    const image = linkImages && linkImages[0];
    const { owner , memberLevel , topicMembers: topicMembersProp ,  } = rootTopicOrSelf || {};
    const rootURL = getItemUrl(topic, owner);
    const topicMembers = useMemo(()=>{
        return ((topicMembersProp === null || topicMembersProp === void 0 ? void 0 : topicMembersProp.nodes) || []).map((topicMember)=>topicMember.user).filter(isPresent);
    }, [
        topicMembersProp === null || topicMembersProp === void 0 ? void 0 : topicMembersProp.nodes
    ]);
    const starTopic = useStarTopic({
        nodeId,
        topicId: id,
        star: !currentUserHasStarred
    });
    return /*#__PURE__*/ _jsxs(TopicWrapper, _objectSpread({
        ref: ref,
        $showBorder: showBorder,
        isActive: navigationItemHelpers === null || navigationItemHelpers === void 0 ? void 0 : navigationItemHelpers.isActive
    }, rest, {
        children: [
            /*#__PURE__*/ _jsx(CardLink, {
                to: rootURL
            }),
            /*#__PURE__*/ _jsxs(CardContent, {
                as: Flex,
                alignItems: "center",
                children: [
                    /*#__PURE__*/ _jsx(TopicImage, {
                        src: image || undefined,
                        size: 56,
                        type: type
                    }),
                    /*#__PURE__*/ _jsxs(TopicDataWrapper, {
                        flex: "1",
                        minWidth: "0",
                        pl: 1,
                        children: [
                            /*#__PURE__*/ _jsxs(Flex, {
                                alignItems: "center",
                                children: [
                                    /*#__PURE__*/ _jsx(Text, {
                                        fontWeight: "bold",
                                        truncate: true,
                                        fontSize: [
                                            "20px",
                                            null,
                                            "16px"
                                        ],
                                        children: title || "No title"
                                    }),
                                    !topic.public && !teamVisible && /*#__PURE__*/ _jsx(Flex, {
                                        as: "span",
                                        ml: 1,
                                        color: "black.60",
                                        children: /*#__PURE__*/ _jsx(LockOutlined, {})
                                    }),
                                    showTeam && owner && /*#__PURE__*/ _jsx(TopicOwnerDesktop, {
                                        as: "span",
                                        ml: 1,
                                        color: "black.60",
                                        children: owner.username
                                    }),
                                    /*#__PURE__*/ _jsxs(RenderIfChildExists, {
                                        component: /*#__PURE__*/ _jsx(Flex, {
                                            ml: "auto",
                                            pl: 2
                                        }),
                                        children: [
                                            topicMembers.length > 1 && /*#__PURE__*/ _jsx(TopicMembersWrapper, {
                                                alignItems: "center",
                                                children: topicMembers.map((topicMember)=>/*#__PURE__*/ _jsx(Avatar, {
                                                        user: topicMember
                                                    }, topicMember.nodeId))
                                            }),
                                            memberLevel && ![
                                                ItemMemberLevel.Invited,
                                                ItemMemberLevel.Pending
                                            ].includes(memberLevel) && /*#__PURE__*/ _jsx(TopicPinButton, {
                                                variant: "circle",
                                                onClick: starTopic,
                                                color: currentUserHasStarred ? "#ffd600" : "black.42",
                                                children: /*#__PURE__*/ _jsx(PushPinOutlined, {})
                                            })
                                        ]
                                    })
                                ]
                            }),
                            showTeam && owner && /*#__PURE__*/ _jsx(TopicOwnerMobile, {
                                as: "span",
                                mt: 0,
                                color: "black.60",
                                children: owner.username
                            })
                        ]
                    })
                ]
            })
        ]
    }));
});
export default Topic;
